module.exports = __webpack_public_path__ + "assets/img/cus1.476af0ee.jpg";